import React from "react";
import { Chip, Stack } from "@mui/material";

const SelectedFiltersChips = ({ filters = {}, onRemoveFilter }) => {
  // Define label mapping for field names
  const fieldLabels = {
    donorId: "Donor ID",
    name: "Name",
    mobile: "Mobile No",
    status: "Status",
    remarks: "Remarks",
    bookNo: "Book No",
    receiptNo: "Receipt No",
  };

  const appliedFilters = Object.entries(filters).filter(
    ([, value]) =>
      (Array.isArray(value) && value.length > 0) ||
      (!Array.isArray(value) && value)
  );

  if (appliedFilters.length === 0) return null;

  return (
    <Stack
      direction="row"
      spacing={1}
      flexWrap="wrap"
      marginTop={1}
      sx={{ marginBottom: 1 }}
    >
      {appliedFilters.map(([key, value]) => {
        const labelName = fieldLabels[key] || key; 
        const label = Array.isArray(value)
          ? `${labelName}: ${value.join(", ")}`
          : `${labelName}: ${value}`;

        return (
          <Chip
            key={key}
            label={label}
            size="small"
            onDelete={() => onRemoveFilter(key)}
            sx={{
              borderRadius: "16px",
              border: "1px solid #000",
              backgroundColor: "#fff",
              color: "#000",
              fontWeight: 500,
              "& .MuiChip-deleteIcon": {
                color: "red",
                "&:hover": {
                  color: "#ff0000",
                },
              },
            }}
          />
        );
      })}
    </Stack>
  );
};

export default SelectedFiltersChips;
